import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, SaveButton } from '_components';
import styles from './CustomTemplate.module.css'

class PatientCareCenterNoteObjectiveCustomTemplate extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            customName: '',
            cancelVisible: false,
            saveVisible: false,
            msg1Visible: false,
        };
    }

    handleChange(event) {
        if (this.props.userTemplates ? Object.keys(this.props.userTemplates)
            .find(x => this.props.userTemplates[x].TENAME === event.target.value) !== undefined ? true : false : false) {
            this.setState({
                customName: event.target.value,
                cancelVisible: true,
                saveVisible: true,
                msg1Visible: true
            });
        } else if (event.target.value !== undefined && event.target.value.trim() !== '') {
            this.setState({
                customName: event.target.value,
                cancelVisible: true,
                saveVisible: true,
                msg1Visible: false
            });
        } else if (event.target.value !== undefined && event.target.value.trim() === '') {
            this.setState({
                customName: event.target.value,
                cancelVisible: false,
                saveVisible: false,
                msg1Visible: false
            });
        }
    }

    saveTemplate() {
        this.props.saveObjectiveTemplate(this.props.noteId, this.state.customName);
        this.setState({
            customName: '',
            cancelVisible: false,
            saveVisible: false,
            msg1Visible: false,
        });
    }

    cancelSave() {
        this.setState({
            customName: '',
            cancelVisible: false,
            saveVisible: false,
            msg1Visible: false,
        });
    }

    render() {
        return (
            <div className={styles.row}>
                <span className={styles.col1}>Save selections as custom template:</span>
                <span className={styles.col2}>
                    <input autoFocus name="customName" type="text" className={styles.custom_name} value={this.state.customName} onChange={event => this.handleChange(event)} />
                </span>
                {this.state.msg1Visible &&
                    <span className={styles.template_button_wrapper}>
                        <span className={styles.warning}>
                            Replace existing template?
                        </span>
                    </span>
                }
                {this.state.saveVisible &&
                    <span className={styles.template_button_wrapper}>
                        <SaveButton title='Save' size='extra-small' onClick={() => this.saveTemplate()} />
                    </span>
                }
                {this.state.cancelVisible &&
                    <span className={styles.template_button_wrapper}>
                        <CancelButton title='Cancel' size='extra-small' onClick={() => this.cancelSave()} />
                    </span>
                }
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        saveObjectiveTemplate: bindActionCreators(noteActions.saveObjectiveTemplate, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let type = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let globalTemplates = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATES)
        .filter(key => { return state.entities.notes.PTOBJECTIVETEMPLATES[key].TEURNO === null && state.entities.notes.PTOBJECTIVETEMPLATES[key].NoteId === noteId })
        .sort((a, b) => state.entities.notes.PTOBJECTIVETEMPLATES[a].TENAME.localeCompare(state.entities.notes.PTOBJECTIVETEMPLATES[b].TENAME))
        .map(key => state.entities.notes.PTOBJECTIVETEMPLATES[key]);

    let globalTemplateIds = Object.keys(globalTemplates).map(x => globalTemplates[x].TENO);

    let globalTemplateSelectedCount = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
        .filter(x => (
            (type === 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBEVNO === pk) ||
            (type !== 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBNTNO === pk)
        ) && globalTemplateIds.includes(state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBTENO)
        ).length;

    return {
        noteId,
        globalTemplates,
        globalTemplateSelectedCount,
        userTemplates: Object.keys(state.entities.notes.PTOBJECTIVETEMPLATES)
            .filter(key => { return state.entities.notes.PTOBJECTIVETEMPLATES[key].TEURNO !== null && state.entities.notes.PTOBJECTIVETEMPLATES[key].NoteId === noteId })
            .sort((a, b) => state.entities.notes.PTOBJECTIVETEMPLATES[a].TENAME.localeCompare(state.entities.notes.PTOBJECTIVETEMPLATES[b].TENAME))
            .map(key => state.entities.notes.PTOBJECTIVETEMPLATES[key]),
    };
}

const connectedPatientCareCenterNoteObjectiveCustomTemplate = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveCustomTemplate);
export { connectedPatientCareCenterNoteObjectiveCustomTemplate as PatientCareCenterNoteObjectiveCustomTemplate };

